export const prefecture_list = [
  { code: '01', name: '北海道' },
  { code: '02', name: '青森県' },
  { code: '03', name: '岩手県' },
  { code: '04', name: '宮城県' },
  { code: '05', name: '秋田県' },
  { code: '06', name: '山形県' },
  { code: '07', name: '福島県' },
  { code: '08', name: '茨城県' },
  { code: '09', name: '栃木県' },
  { code: '10', name: '群馬県' },
  { code: '11', name: '埼玉県' },
  { code: '12', name: '千葉県' },
  { code: '13', name: '東京都' },
  { code: '14', name: '神奈川県' },
  { code: '15', name: '新潟県' },
  { code: '16', name: '富山県' },
  { code: '17', name: '石川県' },
  { code: '18', name: '福井県' },
  { code: '19', name: '山梨県' },
  { code: '20', name: '長野県' },
  { code: '21', name: '岐阜県' },
  { code: '22', name: '静岡県' },
  { code: '23', name: '愛知県' },
  { code: '24', name: '三重県' },
  { code: '25', name: '滋賀県' },
  { code: '26', name: '京都府' },
  { code: '27', name: '大阪府' },
  { code: '28', name: '兵庫県' },
  { code: '29', name: '奈良県' },
  { code: '30', name: '和歌山県' },
  { code: '31', name: '鳥取県' },
  { code: '32', name: '島根県' },
  { code: '33', name: '岡山県' },
  { code: '34', name: '広島県' },
  { code: '35', name: '山口県' },
  { code: '36', name: '徳島県' },
  { code: '37', name: '香川県' },
  { code: '38', name: '愛媛県' },
  { code: '39', name: '高知県' },
  { code: '40', name: '福岡県' },
  { code: '41', name: '佐賀県' },
  { code: '42', name: '長崎県' },
  { code: '43', name: '熊本県' },
  { code: '44', name: '大分県' },
  { code: '45', name: '宮崎県' },
  { code: '46', name: '鹿児島県' },
  { code: '47', name: '沖縄県' },
]

export const day_count = [
  { id: 0, value: 0 },
  { id: 1, value: 1 },
  { id: 2, value: 2 },
  { id: 3, value: 3 },
  { id: 4, value: 4 },
  { id: 5, value: 5 },
  { id: 6, value: 6 },
  { id: 7, value: 7 },
]

export const industry = [
  { id: 1, value: '求人' },
  { id: 2, value: '生協' },
  { id: 3, value: '通販' },
  { id: 4, value: 'エステ' },
  { id: 5, value: '不動産/住宅' },
  { id: 6, value: 'デリバリー' },
  { id: 7, value: '飲食' },
  { id: 8, value: '車/駐車場/カーシェア' },
  { id: 9, value: '不用品回収/リサイクルショップ/買取' },
  { id: 10, value: 'フィットネス/ジム' },
  { id: 11, value: '水道関連' },
  { id: 12, value: '整体/整骨院/鍼灸' },
  { id: 13, value: '介護/看護' },
  { id: 14, value: 'クリニック' },
  { id: 15, value: '美容院/ネイルサロン' },
  { id: 16, value: '通信/携帯' },
  { id: 17, value: '小売' },
  { id: 18, value: 'アプリ' },
  { id: 19, value: 'アパレル' },
  { id: 20, value: '家具/インテリア' },
  { id: 21, value: '警備/清掃' },
  { id: 22, value: '終活' },
  { id: 23, value: '娯楽' },
  { id: 24, value: 'イベント' },
  { id: 25, value: '英会話/学習' },
  { id: 26, value: 'レンタルスペース' },
  { id: 27, value: '弁護士' },
  { id: 28, value: 'その他' },
]

export const product = [
  { id: 1, name: 'one', enable: false },
  { id: 2, name: 'two', enable: false },
  { id: 3, name: 'three', enable: false },
]
